import { lazy } from "react";
import { authRoleAccess } from '../../auth/AuthRoleAccess';

const KDS = lazy(() => import("./KDS"));

const kdsRoutes = [
    {
        path: "/kds",
        component: KDS,
        auth: authRoleAccess.kds,
    },
];

export default kdsRoutes;
